// extracted by mini-css-extract-plugin
export var layoutContainer = "_5o-0";
export var layoutContainerNoRounding = "_5o-6";
export var layoutContainerOpen = "_5o-5";
export var layoutContainerResizing = "_5o-1";
export var mainContent = "_5o-2";
export var resizeDivider = "_5o-3";
export var slidePanel = "_5o-4";